<template>
  <v-container>
    <v-row>
      <!-- 用户头像和昵称 -->
      <v-col cols="12" md="4">
        <v-card class="mb-4">
          <v-card-title>{{ $t('userProfile.profile') }}</v-card-title>
          <v-card-text>
            <v-avatar size="100">
              <img :src="userProfile.avatarUrl" alt="Avatar" />
            </v-avatar>
            <v-text-field
              v-model="nickname"
              :label="$t('userProfile.nickname')"
              outlined
            ></v-text-field>
            <v-btn @click="updateNickname" color="primary">
              {{ $t('userProfile.modify') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 用户信息 -->
      <v-col cols="12" md="8">
        <v-card class="mb-4">
          <v-card-title>{{ $t('userProfile.details') }}</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item>
                <v-list-item-title><v-img rounded bordered :src="userProfile.avatarUrl" width="100" height="100"></v-img></v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>{{ $t('userProfile.nickname') }}</v-list-item-title>
                <v-list-item-subtitle>{{ userProfile.nickname }}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>{{ $t('userProfile.email') }}</v-list-item-title>
                <v-list-item-subtitle>{{ userProfile.email }}</v-list-item-subtitle>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-title>{{ $t('userProfile.role') }}</v-list-item-title>
                <v-list-item-subtitle>{{ userProfile.userRole }}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>{{ $t('userProfile.userName') }}</v-list-item-title>
                <v-list-item-subtitle>{{ userProfile.user_name }}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>{{ $t('userProfile.referrerAddress') }}</v-list-item-title>
                <v-list-item-subtitle>{{ userProfile.referrerAddress }}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>{{ $t('userProfile.walletAddress') }}</v-list-item-title>
                <v-list-item-subtitle>{{ userProfile.walletAddress }}</v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- 绑定邮箱 -->
      <v-col cols="12">
        <v-card class="mb-4">
          <v-card-title>{{ $t('userProfile.email') }}</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="email"
              :label="$t('userProfile.email')"
              outlined
            ></v-text-field>
            <v-btn @click="updateEmail" color="primary">
              {{ $t('userProfile.modify') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import { mapState, mapMutations } from 'vuex';
import { updateUserNickname, updateUserEmail } from '@/api/apiService';

export default {
  name: 'UserProfile',
  computed: {
    ...mapState(['userProfile']),
    nickname: {
      get() {
        return this.userProfile.nickname || '';
      },
      set(value) {
        this.$store.commit('UPDATE_NICKNAME', value);
      },
    },
    email: {
      get() {
        return this.userProfile.email || '';
      },
      set(value) {
        this.$store.commit('UPDATE_EMAIL', value);
      },
    },
  },
  methods: {
    ...mapMutations(['UPDATE_NICKNAME', 'UPDATE_EMAIL']),
    formatValue(value) {
      if(Array.isArray(value)) {
        return value.join(', ');
      }
      return value || 'N/A';
    },
    updateNickname() {
      if(this.nickname === '') {
        this.$toast.error('Nickname cannot be empty');
        return false;
      }
      updateUserNickname(this.nickname).then(response => {
        if(response.data.success) {
          console.log('Nickname updated successfully:', response);
          this.UPDATE_NICKNAME(this.nickname);
          this.$toast.success('Nickname updated successfully');
        } else {
          this.$toast.error('Error updating nickname');
        }
      }).catch(error => {
        console.error('Error updating nickname:', error);
        this.$toast.error('Error updating nickname');
      });
    },
    updateEmail() {
      if(this.email === '') {
        this.$toast.error('Email cannot be empty');
        return false;
      } else {
        updateUserEmail(this.email).then(response => {
          if(response.data.success) {
            console.log('Email updated successfully:', response);
            this.$toast.showToast({
              message: 'Email updated successfully',
              status: 'success',
              timeout: 3000,
              callback: () => {
                this.UPDATE_EMAIL(this.email);
              }
            });
          } else {
            this.$toast.showToast({
              message: 'Error updating email',
              status: 'error',
              timeout: 3000
            });
          }
        }).catch(error => {
          console.error('Error updating email:', error);
          this.$toast.error('Error updating email');
        });
      }
    },
  },
  mounted() {
    if(this.userProfile.avatarUrl === '') {
      this.userProfile.avatarUrl =  localStorage.getItem('avatar') || this.userProfile.avatar || '';
    }
  },
};
</script>

<style scoped>
.user-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
</style>